import { render, staticRenderFns } from "./task-sign-off.vue?vue&type=template&id=53650348&"
import script from "./task-sign-off.vue?vue&type=script&lang=js&"
export * from "./task-sign-off.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53650348')) {
      api.createRecord('53650348', component.options)
    } else {
      api.reload('53650348', component.options)
    }
    module.hot.accept("./task-sign-off.vue?vue&type=template&id=53650348&", function () {
      api.rerender('53650348', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/task/task-sign-off.vue"
export default component.exports